var g = Object.defineProperty;
var o = (s, i, t) => i in s ? g(s, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[i] = t;
var d = (s, i, t) => (o(s, typeof i != "symbol" ? i + "" : i, t), t);
import { fabric as a } from "fabric";
const h = {
  idle: {
    default: {
      visible: !1,
      originX: "center",
      originY: "center",
      fill: "rgba(0,0,0,0)",
      stroke: "rgba(94,99,229,0.4)",
      strokeWidth: 1.5
    },
    light: {},
    dark: {}
  },
  dragStart: {
    default: {
      visible: !0
    },
    light: {},
    dark: {}
  },
  select: {
    default: {
      visible: !0,
      fill: "rgba(0,0,0,0)",
      stroke: "rgba(94,99,229,0.4)",
      strokeWidth: 1.5
    },
    light: {},
    dark: {}
  },
  selectedPOI: {
    default: {
      visible: !0,
      fill: "rgba(0,0,0,0)",
      stroke: "#797DF5",
      strokeWidth: 1.5,
      rx: 8,
      ry: 8
    },
    light: {},
    dark: {}
  }
};
class u extends a.Rect {
  constructor(t, e) {
    const r = t.getBoundingRect(), l = t.getCenterPoint();
    e = {
      ...h.idle.default,
      ...h.idle[e.styleType],
      width: r.width + 6,
      height: r.height + 6,
      rx: 4,
      ry: 4,
      left: l.x,
      top: l.y,
      ...e
    };
    super(e);
    d(this, "curObj");
    d(this, "styleType");
    d(this, "updateStyle", (t, e = "idle") => {
      if (this.styleType = t, e === "dragStart") {
        const r = this.curObj.getBoundingRect(), l = this.curObj.getCenterPoint();
        this.set({
          width: r.width + 6,
          height: r.height + 6,
          left: l.x,
          top: l.y
        });
      }
      if (e === "selectedPOI") {
        const r = this.curObj.getBoundingRect(), l = this.curObj.getCenterPoint();
        this.set({
          width: r.width + 10,
          height: r.height + 10,
          left: l.x,
          top: l.y
        });
      }
      this.set({
        ...h.idle.default,
        ...h.idle[this.styleType],
        ...h[e].default,
        ...h[e][this.styleType]
      });
    });
    this.styleType = e.styleType, this.curObj = t;
  }
}
export {
  u as StatusOuterBox,
  h as outerBoxStyle
};
//# sourceMappingURL=index.es250.js.map
